var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: "42'",
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11, 10) scale(0.65)",
    fill: "#033476"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.188 13.925h-3.161c-1.654 0-3 1.346-3 3v9.915c0 1.654 1.346 3 3 3h3.161c1.654 0 3-1.346 3-3v-9.915c0-1.654-1.346-3-3-3zm1 12.915c0 .551-.449 1-1 1h-3.161c-.551 0-1-.449-1-1v-9.915c0-.551.449-1 1-1h3.161c.551 0 1 .449 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.973 13.925h-10.166c-1.654 0-3 1.346-3 3v9.915c0 1.654 1.346 3 3 3h10.166c1.654 0 3-1.346 3-3v-9.915c0-1.654-1.346-3-3-3zm1 12.915c0 .551-.449 1-1 1h-10.166c-.551 0-1-.449-1-1v-9.915c0-.551.449-1 1-1h10.166c.551 0 1 .449 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.027 11.922h9.938c1.654 0 3-1.346 3-3v-3.895c0-1.654-1.346-3-3-3h-9.938c-1.654 0-3 1.346-3 3v3.895c0 1.654 1.346 3 3 3zm-1-6.895c0-.551.449-1 1-1h9.938c.551 0 1 .449 1 1v3.895c0 .551-.449 1-1 1h-9.938c-.551 0-1-.449-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.973 2.027h-3.403c-1.654 0-3 1.346-3 3v3.895c0 1.654 1.346 3 3 3h3.403c1.654 0 3-1.346 3-3v-3.895c0-1.654-1.346-3-3-3zm1 6.895c0 .551-.449 1-1 1h-3.403c-.551 0-1-.449-1-1v-3.895c0-.551.449-1 1-1h3.403c.551 0 1 .449 1 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/app.78b55f4a27547cc683fc5e593b63c901.svg";
export { ForwardRef as ReactComponent };